import { ChangeDetectionStrategy, Component, computed, ViewEncapsulation } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { WorkflowActionInputComponent } from "./workflow.action.input.component";
import { SystemActionComponent } from "./abstract.system.action.component";
import { S25DropdownPaginatedModule } from "../../s25-dropdown/s25.dropdown.paginated.module";
import { DropDownItem } from "../../../pojo/DropDownItem";

@Component({
    standalone: true,
    selector: "s25-ng-workflow-set-org-status-action",
    template: `
        <div class="form-group">
            <label>Rating *</label>
            <s25-ng-dropdown-search-criteria
                [type]="'organizationRatings'"
                [value]="selectedRating()"
                (valueChange)="onRatingChange($event)"
                [placeholder]="'Select Rating'"
            />
            <small class="form-text">Select the rating to apply to the organization</small>
        </div>

        <s25-ng-workflow-action-input
            class="system-input"
            [value]="inputMap()['organizationIdField']?.inputValue"
            (valueChange)="setInputValue('organizationIdField', $event)"
            [label]="'Organization ID Field'"
            [type]="'text'"
            [required]="false"
            [help]="
                'For forms without an implied organization, map a form field containing the organization ID (e.g., $CNET-123-ORG_ID). Forms with an implied organization automatically have organization ID available.'
            "
            [acceptedAnswerTypes]="acceptedFor('organizationIdField')"
        />
    `,
    styles: `
        .form-group {
            margin-bottom: 16px;
        }

        .form-group label {
            display: block;
            margin-bottom: 4px;
            font-weight: 500;
            color: #555;
        }

        .form-text {
            color: #666;
            font-size: 12px;
            margin-top: 4px;
            display: block;
        }

        .system-input {
            margin-bottom: 16px;
        }

        .system-input:last-child {
            margin-bottom: 0;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [FormsModule, WorkflowActionInputComponent, S25DropdownPaginatedModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetOrgStatusActionComponent extends SystemActionComponent {
    protected readonly actionCode = "SET_ORG_STATUS" as const;
    readonly selectedRating = computed<DropDownItem | null>(() => {
        const ratingIdInput = this.inputMap()["ratingId"];
        if (!ratingIdInput?.inputValue) return null;
        const ratingId = parseInt(ratingIdInput.inputValue, 10);
        if (isNaN(ratingId)) return null;
        return {
            itemId: ratingId,
            itemTypeId: undefined,
            txt: "",
            val: ratingId.toString(),
        } as DropDownItem;
    });

    onRatingChange(rating: DropDownItem | null) {
        if (rating?.itemId) {
            this.setInputValue("ratingId", rating.itemId.toString());
        } else {
            this.setInputValue("ratingId", "");
        }
    }
}
